const HEARTBEAT_INTERVAL = 20000; // 20 seconds
const MAX_RETRIES = 10;


class WebSocketManager {
    constructor(url) {
        this.url = url;
        //this.heartbeatInterval = null;
        this.retryCount = 0;
        this.connecting = false;
        this.reconnectTimer = null;
        this.onMessageCallbacks = [];
        this.pingInterval = null;
        this.setupKeepAlive();
        this.connect();
    }


    setupKeepAlive() {
        // Avoid starting multiple ping intervals (constructor + onopen previously caused duplicates).
        if (this.pingInterval) return;

        this.pingInterval = setInterval(() => {
            if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) {
                this.webSocket.send("ping");
            }
        }, HEARTBEAT_INTERVAL);
    }

    scheduleReconnect() {
        if (this.connecting) return;
        if (this.retryCount >= MAX_RETRIES) return;

        this.retryCount += 1;
        const delayMs = Math.min(30000, 500 * Math.pow(2, this.retryCount - 1));

        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
        }

        this.reconnectTimer = setTimeout(() => {
            this.reconnectTimer = null;
            this.connect();
        }, delayMs);
    }

    connect() {
        if (this.retryCount >= MAX_RETRIES) {
            console.log("WebSocket connection failed after maximum retries.");
            return;
        }

        if (this.connecting) return;
        if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) return;

        this.connecting = true;
        this.webSocket = new WebSocket(this.url);

        console.log(`WebSocket client started.`);

        this.webSocket.onopen = () => {
            this.connecting = false;
            this.retryCount = 0;
            // Keep-alive already running (or will run once).
        };

        this.webSocket.onmessage = (event) => {
            this.handleWebSocketMessage(event);
        };
            /*
            this.webSocket.onclose = () => {
                this.stopHeartbeat();
                this.webSocket = null;
                // Reconnect here if needed, or handle reconnection elsewhere
            };
            */
        this.webSocket.onclose = () => {
            this.connecting = false;
            this.webSocket = null;
            this.scheduleReconnect();
        };

        this.webSocket.onerror = () => {
            this.connecting = false;
            this.webSocket = null;
            this.scheduleReconnect();
        };
    }

    reconnect() {
        this.scheduleReconnect();
    }

    /*
        stopKeepAlive() {
            clearInterval(this.pingInterval);
            this.pingInterval = null;
        }*/

    /*
        startHeartbeat() {
            this.heartbeatInterval = setInterval(() => {
                if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) {
                    this.webSocket.send("ping");
                }
            }, HEARTBEAT_INTERVAL);
        }
    
        stopHeartbeat() {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    
    close() {
        if (this.webSocket) {
            this.webSocket.close();
            this.stopHeartbeat();
            this.webSocket = null;
        }
    }
    */

    setOnMessageCallback(callback) {
        this.onMessageCallbacks.push(callback);
    }

    removeOnMessageCallback(callback) {
        this.onMessageCallbacks = this.onMessageCallbacks.filter(
            (cb) => cb !== callback
        );
    }

    handleWebSocketMessage(event) {
        if (event.data === "pong") {
            return; // Ignore heartbeat responses
        }
        this.onMessageCallbacks.forEach((callback) => {
            callback(event);
        });
    }
}

export default WebSocketManager;
